var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"full-width full-height"})
}
var staticRenderFns = []

export { render, staticRenderFns }